<mat-nav-list>
  @for (help of data.help; track help) {
    <a mat-list-item class="display-block" [disableRipple]="true" tabindex="0" role="link" attr.aria-label="{{ help.question }}">
      @if (help.question) {
        <span mat-line class="heading mr-3">{{ help.question }}</span>
      }
      <button mat-icon-button aria-label="Close" color="primary" class="close" (click)="onClose()" tabindex="0">
        <mat-icon>close</mat-icon>
      </button>
      @if (!data.isRaw) {
        @if (help.answer && checkIfArray(help.answer) === false) {
          <span mat-line class="body">{{ help.answer }}</span>
        }
        @if (checkIfArray(help.answer)) {
          <div mat-line class="body">
            <ul class="my-0">
              @for (answer of help.answer; track answer) {
                <li>{{ answer }}</li>
              }
            </ul>
          </div>
        }
      }
      @if (data.isRaw) {
        <div [innerHTML]="help.answer"></div>
      }
    </a>
  }
</mat-nav-list>

<div class="action__row">
  <button mat-button aria-label="Close" (click)="onClose()" tabindex="0">Close</button>
</div>
